module.exports = __webpack_public_path__ + "static/wo1-de9886b7cdcc0c7b5bf49a1fe8e435f8.png";